/**
 * export types
 */
export * from './magnification';
